const assertEndsWithSideSuffix = (value: string, side: "L" | "R") => {
	const lowerValue = value.toLowerCase();
	const lowerSide = side.toLowerCase();
	return (
		lowerValue.endsWith(`_${lowerSide}.stl`) ||
		lowerValue.endsWith(`-${lowerSide}.stl`)
	);
};

export const assertIsValidEarprintFileName = (
	value: string,
	side: "L" | "R",
) => {
	return assertEndsWithSideSuffix(value, side);
};
